
export const strings = {
    en: {
      imprint: 'Legal notice',
      imprintLink: 'https://www.aufzughelden.com/de/impressum',
      dataProtection: 'Privacy',
      dataProtectionLink: 'https://www.aufzughelden.com/de/datenschutz',
      footerText: '© Aufzughelden 2023. All rights reserved',
      contact :'Contact',
      followUs :'Follow us.',
      writeUs : 'Contact us',
    },
    de: {
      imprint: 'Impressum',
      imprintLink: 'https://www.aufzughelden.com/de/impressum',
      dataProtection: 'Datenschutz',
      dataProtectionLink: 'https://www.aufzughelden.com/de/datenschutz',
      footerText: '© Aufzughelden 2023. Alle Rechte vorbehalten',
      contact :'Kontakt',
      followUs :'Folgen Sie uns.',
      writeUs : 'Schreiben Sie uns',
    },
  };